module.exports = __webpack_public_path__ + "img/novo-pre-analise-credito.897d0c12.svg";